module.exports = __webpack_public_path__ + "static/media/feature.55607d69.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/CCIWA/feature.jpg
// module id = 217
// module chunks = 0